var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"guide-tips-wrap",style:(_vm._f("transRpxStyle")([(_vm.wrapStyle)]))},[_c('mpx-image',{staticClass:"icon",attrs:{"src":(_vm.icon)}}),_c('div',{staticClass:"title",style:(_vm._f("transRpxStyle")([(_vm.titleStyle)]))},[_c('mpx-rich-text',{attrs:{"nodes":(_vm.title)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }